import type * as React from 'react';
import styles from './style.m.less';

export const LoadingIcon: React.FC<React.PropsWithChildren> = ({ children }) => (
    <div className={styles.container}>
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            preserveAspectRatio="xMaxYMid slice"
            focusable="false"
            className={styles.icon}
        >
            {children}
        </svg>
    </div>
);
